// Revised on 2025/05/13 by mnavarro
import { createApp } from 'vue';
import Notification from '@/picko_components/generic_components/Notification.vue';

let activeNotifications = [];
let container = null;

const NotificationPlugin = {
    install(app) {
        app.config.globalProperties.$notify = (options) => {
            
            if (!container) {
                container = document.createElement('div');
                container.id = 'notification-container';
                container.style.zIndex = '9999999999';
                container.className = 'position-fixed top-2 end-2';
                document.body.appendChild(container);
            }

            const wrapper = document.createElement('div');
            container.appendChild(wrapper);

            const NotificationConstructor = createApp(Notification, {
                ...options,
                onClose: () => {
                wrapper.remove();
                const index = activeNotifications.indexOf(instance);
                if (index !== -1) activeNotifications.splice(index, 1);
                },
            });

            const instance = NotificationConstructor.mount(wrapper);
            activeNotifications.push(instance);

            if (options.duration) {
                setTimeout(() => {
                if (instance && typeof instance.close === 'function') {
                    instance.close();
                } else {
                    wrapper.remove();
                }
                }, options.duration);
            }
        };
    },
};

export default NotificationPlugin;